export const formFields = [
  {
    section: "General Information",
    name: "tscScheduleName",
    label: "Schedule",
    fieldLabel: "TSC Schedule Name",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 10, message: "MAXLENGTH_10" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [1, 1],
  },
  {
    section: "General Information",
    name: "tscDescription",
    label: "Description",
    fieldLabel: "TSC Description",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 25, message: "MAXLENGTH_25" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [2, 1],
  },
  {
    section: "General Information",
    name: "tscVersion",
    label: "Version",
    fieldLabel: "TSC Version",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 2, message: "MAXLENGTH_2" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [3, 1],
  },
  {
    section: "General Information",
    name: "tscStepCount",
    label: "Steps",
    fieldLabel: "TSC Step Count",
    type: "number",
    options: {
      required: { value: true, message: "REQUIRED" },
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [4, 1],
  },
  {
    section: "General Information",
    name: "tscCrossOverFlag",
    label: "Cross Over",
    fieldLabel: "TSC Cross Over Flag",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 1],
  },
  {
    section: "General Information",
    name: "tscTroopAccumCompCode",
    label: "TrOOP Accum Code",
    fieldLabel: "TSC Troop Accum Comp Code",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 2, message: "MAXLENGTH_2" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [6, 1],
  },
  {
    section: "General Information",
    name: "tsdDrugSpendAccumComp",
    label: "Drug Spend Accum Code",
    fieldLabel: "TSD Drug Spend Accum Comp",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [7, 1],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["01"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
  {
    section: "General Information",
    name: "tscCoverageGapCalc",
    label: "Coverage Gap Calc",
    fieldLabel: "TSC Coverage Gap Calc",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [8, 1],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["01"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
  {
    section: "General Information",
    name: "tsdStepNumber",
    label: "Step",
    fieldLabel: "Wrk TSD Step Number",
    type: "number",
    options: {
      required: { value: true, message: "REQUIRED" },
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [9, 1],
  },
  {
    section: "General Information",
    name: "tsdTroopAmount",
    label: "TrOOP Maximum Amount",
    fieldLabel: "TSD TrOOP Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      required: { value: true, message: "REQUIRED" },
      min: { value: 0.0, message: "MIN_0.00" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 1],
  },
  {
    section: "General Information",
    name: "tsdDrugSpend",
    label: "Drug Spend Maximum Amount",
    fieldLabel: "TSD Drug Spend",
    type: "number",
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["01"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
    fractionDigits: 2,
    options: {
      required: { value: true, message: "REQUIRED" },
      min: { value: 0.0, message: "MIN_0.00" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 1],
  },
  {
    section: "General Information",
    name: "planCode",
    label: "Plan Override",
    fieldLabel: "TSD Plan Code",
    type: "lookup",
    externalProgram: { default: "RCPLN018" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          { source: "planCode", target: "planCode", legacy: "planCode" },
          {
            source: "planEffDate",
            resolver: "formatDateForPresto",
            legacy: "planEffDate",
            target: "planEffDate",
          },
        ],
      },
    },

    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 1],
  },
  {
    section: "General Information",
    name: "planEffDate",
    label: "Plan From Date",
    fieldLabel: "TSD Plan Eff Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: { maxLength: { value: 10, message: "MAXLENGTH_6" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 2],
  },
  {
    section: "Table Format",
    type: "label",
    label: "Multi-source Code",
    position: [14, 1],
    format: "columnHeader",
  },
  {
    section: "Table Format",
    type: "label",
    label: "M",
    position: [14, 2],
    format: "columnHeader",
  },
  {
    section: "Table Format",
    type: "label",
    label: "N",
    position: [14, 3],
    format: "columnHeader",
  },
  {
    section: "Table Format",
    type: "label",
    label: "O",
    position: [14, 4],
    format: "columnHeader",
  },
  {
    section: "Table Format",
    type: "label",
    label: "Y",
    position: [14, 5],
    format: "columnHeader",
  },
  {
    section: "Table Format",
    type: "label",
    label: "TrOOP Accum",
    position: [15, 1],
  },
  {
    section: "Table Format",
    name: "tsdTrpGenIndIeForM",
    label: "",
    fieldLabel: "PBD MSC I/E for Y",
    type: "dropdown",
    dropdownCondition: "Include/Exclude",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [15, 2],
  },
  {
    section: "Table Format",
    name: "tsdTrpGenIndIeForN",
    label: "",
    fieldLabel: "PBD MSC I/E for Y",
    type: "dropdown",
    dropdownCondition: "Include/Exclude",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [15, 3],
  },
  {
    section: "Table Format",
    name: "tsdTrpGenIndIeForO",
    label: "",
    fieldLabel: "PBD MSC I/E for Y",
    type: "dropdown",
    dropdownCondition: "Include/Exclude",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [15, 4],
  },
  {
    section: "Table Format",
    name: "tsdTrpGenIndIeForY",
    label: "",
    fieldLabel: "PBD MSC I/E for Y",
    type: "dropdown",
    dropdownCondition: "Include/Exclude",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [15, 5],
  },
  {
    section: "Table Format",
    type: "label",
    label: "DS Accum",
    position: [16, 1],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["01"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
  {
    section: "Table Format",
    name: "tsdDsGenIndIeForM",
    label: "",
    fieldLabel: "PBD MSC I/E for Y",
    type: "dropdown",
    dropdownCondition: "Include/Exclude",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 2],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["01"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
  {
    section: "Table Format",
    name: "tsdDsGenIndIeForN",
    label: "",
    fieldLabel: "PBD MSC I/E for Y",
    type: "dropdown",
    dropdownCondition: "Include/Exclude",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 3],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["01"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
  {
    section: "Table Format",
    name: "tsdDsGenIndIeForO",
    label: "",
    fieldLabel: "PBD MSC I/E for Y",
    type: "dropdown",
    dropdownCondition: "Include/Exclude",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 4],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["01"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
  {
    section: "Table Format",
    name: "tsdDsGenIndIeForY",
    label: "",
    fieldLabel: "PBD MSC I/E for Y",
    type: "dropdown",
    dropdownCondition: "Include/Exclude",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 5],
    displayConditions: [
      {
        dependentField: "tscVersion",
        dependentFieldValues: ["01"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
  {
    section: "Patient Pay (Header)",
    name: "tsdSchedFlag",
    label: "Schedule Flag",
    fieldLabel: "TSD Sched Flag",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 1],
  },
  {
    section: "Patient Pay (Header)",
    name: "tsdBrandCopayAmount",
    label: "Brand Amount",
    fieldLabel: "TSD Brand Copay Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0.0, message: "MIN_0.00" },
      max: { value: 99999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [19, 10],
  },
  {
    section: "Patient Pay (Header)",
    name: "tsdBrandPercentAmt",
    label: "Brand Percent",
    fieldLabel: "TSD Brand Percent Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0.0, message: "MIN_0.00" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [19, 20],
  },
  {
    section: "Patient Pay (Header)",
    name: "tsdGenericCopayAmount",
    label: "Generic Amount",
    fieldLabel: "TSD Generic Copay Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0.0, message: "MIN_0.00" },
      max: { value: 99999.99, message: "MAX_99999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [20, 10],
  },
  {
    section: "Patient Pay (Header)",
    name: "tsdGenericPercentAmt",
    label: "Generic Percent",
    fieldLabel: "TSD Generic Percent Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0.0, message: "MIN_0.00" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [20, 11],
  },
  {
    section: "Patient Pay (Header)",
    name: "tsdPharmacyPatientPay",
    label: "Pharmacy Schedule",
    fieldLabel: "TSD Pharmacy Patient Pay",
    type: "lookup",
    externalProgram: { default: "RCPS3001" },
    params: {
      lookupType: "external",
      viewType: "external",
      fieldMapping: {
        default: [
          {
            source: "tsdPharmacyPatientPay",
            target: "ps3PatientPaySchName",
            legacy: "ps3PatientPaySchName",
          },
          {
            source: "",
            target: "ps3PatientPaySchDesc",
            legacy: "ps3PatientPaySchDesc",
          },
        ],
      },
      appName: "PATIENT_PAY",
      pageName: "PATIENT_PAY_SCHEDULE",
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [21, 10],
  },
  {
    section: "Patient Pay (Header)",
    name: "tsdClientPatientPayPs",
    label: "Client Schedule",
    fieldLabel: "TSD Client Patient Pay PS",
    type: "lookup",
    externalProgram: { default: "RCPS3001" },
    params: {
      lookupType: "external",
      viewType: "external",
      // viewType:"legacy",
      fieldMapping: {
        default: [
          {
            source: "tsdClientPatientPayPs",
            target: "ps3PatientPaySchName",
            legacy: "ps3PatientPaySchName",
          },
          {
            source: "",
            target: "ps3PatientPaySchDesc",
            legacy: "ps3PatientPaySchDesc",
          },
        ],
      },
      appName: "PATIENT_PAY",
      pageName: "PATIENT_PAY_SCHEDULE",
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [21, 20],
  },
  {
    section: "Patient Pay (Header)",
    name: "tsdPercentBasis",
    label: "Percent Basis",
    fieldLabel: "TSD Percent Basis",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 2, message: "MAXLENGTH_2" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [24, 1],
  },
  {
    section: "Patient Pay (Header)",
    name: "tsdUpdateFlag",
    label: "Update",
    fieldLabel: "TSD Update Flag",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [25, 1],
  },
  {
    section: "Patient Pay (Header)",
    name: "tsdCoverageLevel",
    label: "Coverage Level",
    fieldLabel: "TSD Coverage Level",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [26, 1],
  },

  {
    section: "Process",
    type: "label",
    label: "Multi-Source Code",
    position: [27, 1],
    format: "columnHeader",
  },
  {
    section: "Process",
    type: "label",
    label: "M",
    position: [27, 2],
    format: "columnHeader",
  },
  {
    section: "Process",
    type: "label",
    label: "N",
    position: [27, 3],
    format: "columnHeader",
  },
  {
    section: "Process",
    type: "label",
    label: "O",
    position: [27, 4],
    format: "columnHeader",
  },
  {
    section: "Process",
    type: "label",
    label: "Y",
    position: [27, 5],
    format: "columnHeader",
  },
  { section: "Process", type: "label", label: "Process", position: [28, 1] },
  {
    section: "Process",
    name: "tsdGenIndProcessForM",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [28, 2],
  },
  {
    section: "Process",
    name: "tsdGenIndProcessForN",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [28, 3],
  },
  {
    section: "Process",
    name: "tsdGenIndProcessForO",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [28, 4],
  },
  {
    section: "Process",
    name: "tsdGenIndProcessForY",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [28, 5],
  },
  {
    section: "TierLabelField",
    type: "label",
    label: "Tier",
    position: [29, 1],
  },
  {
    section: "TierLabelField",
    type: "label",
    label: "00",
    position: [29, 2],
  },
  {
    section: "TierLabelField",
    type: "label",
    label: "01",
    position: [29, 3],
  },
  {
    section: "TierLabelField",
    type: "label",
    label: "02",
    position: [29, 4],
    format: "columnHeader",
  },
  {
    section: "TierLabelField",
    type: "label",
    label: "03",
    position: [29, 5],
  },
  {
    section: "TierLabelField",
    type: "label",
    label: "04",
    position: [29, 6],
  },
  {
    section: "TierLabelField",
    type: "label",
    label: "05",
    position: [29, 7],
  },
  {
    section: "TierLabelField",
    type: "label",
    label: "06",
    position: [29, 8],
  },
  {
    section: "TierLabelField",
    type: "label",
    label: "07",
    position: [29, 9],
  },
  {
    section: "TierLabelField",
    type: "label",
    label: "08",
    position: [29, 10],
  },
  {
    section: "TierLabelField",
    type: "label",
    label: "09",
    position: [29, 11],
  },

  { section: "TierProcessField", type: "label", label: "Process", position: [30, 1] },

  {
    section: "TierProcessField",
    name: "tsdProcessTier00",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 2],
  },
  {
    section: "TierProcessField",
    name: "tsdProcessTier01",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 3],
  },
  {
    section: "TierProcessField",
    name: "tsdProcessTier02",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 4],
  },
  {
    section: "TierProcessField",
    name: "tsdProcessTier03",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 5],
  },
  {
    section: "TierProcessField",
    name: "tsdProcessTier04",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 6],
  },
  {
    section: "TierProcessField",
    name: "tsdProcessTier05",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 7],
  },
  {
    section: "TierProcessField",
    name: "tsdProcessTier06",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 8],
  },
  {
    section: "TierProcessField",
    name: "tsdProcessTier07",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 9],
  },
  {
    section: "TierProcessField",
    name: "tsdProcessTier08",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 10],
  },
  {
    section: "TierProcessField",
    name: "tsdProcessTier09",
    label: "",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [30, 11],
  },

  {
    section: "Plan TrOOP Schedule Step Patient Pay Overrides (Header)",
    name: "tsdPatpayovrPriorAuth",
    label: "Prior Authorization",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [40, 1],
  },
  {
    section: "Plan TrOOP Schedule Step Patient Pay Overrides (Header)",
    name: "tsdPatpayovrNdcGpiLst",
    label: "Plan NDC/GPI List",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [41, 1],
  },
  {
    section: "Plan TrOOP Schedule Step Patient Pay Overrides (Header)",
    name: "tsdPatpayovrPrefndcGpi",
    label: "Preferred NDC/GPI List",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [42, 1],
  },
  {
    section: "Plan TrOOP Schedule Step Patient Pay Overrides (Header)",
    name: "tsdPatpayovrTransBen",
    label: "Transitional Benefit",
    fieldLabel: "/ Yes/No",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [43, 1],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [44, 1],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [44, 2],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [44, 3],
  },
  {
    section: "Audit Fields",
    name: "messageCodeIndicator",
    label: "Message Code Ind",
    fieldLabel: "Message Code Ind",
    type: "text",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [44, 4],
  },
];

export const screenInfo = {
  ADD: ["Add TrOOP Schedule Step Detail", "RCTSD002"],
  CHANGE: ["TrOOP Schedule Step Detail", "RCTSD002"],
  VIEW: ["TrOOP Schedule Step Detail", "RCTSD002"],
};